import React, { useContext, useEffect, useState } from 'react';
import EmpresaContext from '../context/empresa-context';
import WhatsAppContext from '../context/whatsapp-context';
import './WhatsAppButton.css';

const NUMERO = '595984094677';

const WhatsAppButton = () => {
  const [descripcionEmpresa, setDescripcionEmpresa] = useState('Sin definir');
  const [descripcionProducto, setDescripcionProducto] = useState('Sin definir');
  const { empresa, producto, productos, getProductoActual } = useContext(
    EmpresaContext
  );
  const { texto } = useContext(WhatsAppContext);

  let whatsapp = NUMERO;
  if (
    getProductoActual().empresaProducto &&
    getProductoActual().empresaProducto.length > 0
  ) {
    whatsapp =
      getProductoActual().empresaProducto.find(
        (item) => item.id_empresa === empresa.id
      )?.whatsapp || NUMERO;
  }
  useEffect(() => {
    if (empresa && empresa.nombre) {
      setDescripcionEmpresa(empresa.nombre);
    }
  }, [empresa]);

  useEffect(() => {
    if (producto > 0 && productos && productos.length > 0) {
      setDescripcionProducto(getProductoActual().descripcion);
    }
  }, [producto, productos, getProductoActual]);

  const textoFinal = `Cliente: ${descripcionEmpresa}. \nProducto: ${descripcionProducto}. \n${texto}\n\n`;

  return (
    <a
      id="floating_button_sirena"
      className="widget_bg1 right"
      href={`https://wa.me/${whatsapp}?text=${encodeURI(textoFinal)}`}
      rel="noopener noreferrer"
      target="_blank"
    >
      <img
        src="/images/whatsapp-logo.png"
        alt="WhatsApp logo"
        id="widget_logo"
        style={{ right: 10 }}
      />
    </a>
  );
};

export default WhatsAppButton;
